import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectCategoryData } from "../../features/categories/categorySlice";
import { EnhancedInputField } from "./EnhancedInputField";
import axios from "axios";
import { API } from "../../shared/api/Api";
import { selectUserInformations } from "../../features/authSlice";
import { showToast } from "../../utils/utils";

const CategoryItems = ({
  field,
  formData,
  type,
  handleChange,
  disabled = false,
}) => {
  const category = useSelector(selectCategoryData);
  const user = useSelector(selectUserInformations);
  const [allCategories, setAllCategories] = useState(category?.items || []);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  // Load more categories with pagination
  const loadMoreCategories = useCallback(async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const { data } = await axios.get(API.Categories.app_categories_all, {
        params: {
          page: currentPage + 1,
          limit: 20,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (data.status === 200 && data.errorCode === 0) {
        const newItems = data.data.items || [];
        setAllCategories((prev) => [...prev, ...newItems]);
        setCurrentPage((prev) => prev + 1);
        setHasMore(data.data.current_page < data.data.last_page);
      }
    } catch (error) {
      showToast("Error", "Failed to load more categories", "error");
    } finally {
      setLoading(false);
    }
  }, [currentPage, hasMore, loading, user.token]);

  // Initialize with Redux data if available
  React.useEffect(() => {
    if (category?.items && allCategories.length === 0) {
      setAllCategories(category.items);
      setHasMore(category.total > category.items.length);
    }
  }, [category, allCategories.length]);

  const options = allCategories.map((item) => ({
    id: item.id,
    name: item.title,
    title: item.title,
  }));

  return (
    <EnhancedInputField
      key={field.name}
      label={field.label}
      name={field.name}
      type={field.type}
      placeholder={field.placeholder}
      value={formData[field.name]}
      handleChange={handleChange}
      options={options}
      disabled={disabled}
      onLoadMore={hasMore ? loadMoreCategories : null}
      hasMore={hasMore}
      loading={loading}
    />
  );
};

export default CategoryItems;
